import React from 'react';
import {
    View,
    StyleSheet,
    FlatList,
    Platform,
} from 'react-native';
import { connect } from 'react-redux';
import { Heading, HeadingTypes } from 'fitbeat.react-native-components';
import UserDataConsumer from '../utils/UserDataConsumer';
import Theme from '../theme';
import moment from 'moment-timezone';
import { translate } from "react-i18next";
import {
    StatsHistoryHeader,
    StatsHistoryRow,
} from './components';
import { BodyScanReport } from '../Stats/components/BodyScanReport';
import { LoadingModal, toggleScanReportModalVisible } from '../ui';
import {
    sortByDate,
    sortByBodyWeight,
    sortByMuscleMass,
    sortByBodyFat,
} from './utils'
import { trackingHealthHistoryTabSelected } from './actions';

class HealthStatsHistoryScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            history: [],
            field: 'date',
            order: 'down',
            sortbyFn: sortByDate,
            isLoading: true,
            currentStatsHistory: {},
            renderHistoryRows: true,
            pdf: null,
            isLoadingPdf: false,
            pdfReportDate: null,
            pdfError: null
        };

        this.getHealthStatsHistory();
    }

    getHealthStatsHistory = async () => {
        const { sortbyFn, field, order } = this.state;
        const { getMyBodyScans } = this.props.user.userProfileService;

        await this.setState({ isLoading: true });
        const history = await getMyBodyScans();

        await this.sort(sortbyFn, field, history, order);
    }

    componentDidMount() {
        this.willFocusListener = this.props.navigation.addListener('didFocus', async () => {
            this.props.trackingHealthHistoryTabSelected();
            await this.getHealthStatsHistory()
        });
        this.props.trackingHealthHistoryTabSelected();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const stateChanged = JSON.stringify(this.state) !== JSON.stringify(nextState);
        return nextState.isLoading !== this.state.isLoading ||
        nextProps.isScanReportModalVisible !== this.props.isScanReportModalVisible ||
            stateChanged;
    }

    openScanReport = async (scan) => {
        try {
            if (Platform.OS !== 'web') {
                this.openScanReportModal();
            }
            await this.setState({ isLoadingPdf: true, pdfReportDate: scan.dateOfScanDateOnly, pdfError: null });
            const report = await this.props.user.userProfileService.getBodyScanPdf(scan.id);
            await this.setState({ pdf: report.attachment });
        } catch (error) {
            this.setState({ pdfError: error });
        } finally {
            this.setState({ isLoadingPdf: false });
        }
    }

    openScanReportModal = () => {
        this.props.toggleScanReportModalVisible(true);
    }

    closeScanReportModal = () => {
        this.props.toggleScanReportModalVisible(false);
    }

    getReverseOrder = (order) => order == 'down' ? 'up' : 'down';

    sort = async (sortbyFn, field, history, forcedOrder) => {
        await this.setState({
            isLoading: true,
        });

        setTimeout(async () => {
            let { order, field: stateField, } = this.state;
            if (forcedOrder) {
                order = forcedOrder;
            } else if (stateField !== field) {
                order = 'down';
            } else {
                order = this.getReverseOrder(order);
            }
            const sortedHistory = sortbyFn(history, order);
            await this.setState({
                history: sortedHistory,
                field,
                order,
                sortbyFn,
                isLoading: false,
                pdf: null,
                isLoadingPdf: false,
                pdfReportDate: null,
                pdfError: null
            });
        }, 0);
    }

    sortByDate = async () => {
        this.sort(sortByDate, 'date', this.state.history);
    }

    sortByBodyWeight = async () => {
        this.sort(sortByBodyWeight, 'bodyWeight', this.state.history);
    }

    sortByMuscleMass = async () => {
        this.sort(sortByMuscleMass, 'muscleMass', this.state.history);
    }

    sortByBodyFat = async () => {
        this.sort(sortByBodyFat, 'bodyFat', this.state.history);
    }

    render() {
        const { t, isScanReportModalVisible, lastScanDate, user } = this.props;
        const {
            userProfile: {
                uid
            }
        } = user;
        const { history, isLoading } = this.state;

        if (isLoading) {
            return (
                <View style={styles.container}>
                    <LoadingModal isLoading style={styles.container} />
                </View>
            )
        }
        const totalLength = 30;
        const historyRender = history.slice(0, totalLength + 1);
        return (
            <View style={styles.container}>
                {this.state.renderHistoryRows &&
                    <FlatList
                        data={historyRender}
                        removeClippedSubviews={true}
                        extraData={this.state}
                        showsVerticalScrollIndicator={false}
                        keyExtractor={item => item._id}
                        contentContainerStyle={{ overflow: 'hidden' }}
                        stickyHeaderIndices={[0]}
                        ListHeaderComponent={!isLoading && history.length > 0 &&
                            <StatsHistoryHeader
                                sortByDate={this.sortByDate}
                                sortByBodyWeight={this.sortByBodyWeight}
                                sortByMuscleMass={this.sortByMuscleMass}
                                sortByBodyFat={this.sortByBodyFat}
                                field={this.state.field}
                                order={this.state.order}
                            />
                        }
                        ListEmptyComponent={
                            !isLoading && <Heading
                                title='You have no stats history yet.'
                                style={styles.noHistoryText}
                                headingType={HeadingTypes.HEADING_TWO}
                            />
                        }
                        renderItem={({ item, index }) => (
                            <StatsHistoryRow
                                index={index}
                                userId={uid}
                                statsHistory={item}
                                openStatsReport={this.openScanReport}
                            />
                        )}
                    />
                }

                <BodyScanReport
                    t={t}
                    pdf={this.state.pdf}
                    scanDate={moment(this.state.pdfReportDate).format('D MMMM YYYY   |   HH:mm')}
                    closeModal={this.closeScanReportModal}
                    isModalVisible={this.props.isScanReportModalVisible}
                    error={this.state.pdfError}
                    isLoading={this.state.isLoadingPdf}
                />
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Theme.GREY_LIGHT,
    },
    buttonContainer: {
        flex: 1,
    },
    rowContainer: {
        flex: 1,
        flexDirection: 'row',
    },
    noHistoryText: {
        ...Theme.textStyle.bodyCopyMed,
        textAlign: 'center',
        color: Theme.WHITE
    },
});

const mapStateToProps = (state) => {
    return {
        isScanReportModalVisible: state.ui.scanReportModalVisible
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleScanReportModalVisible: (visible) => dispatch(toggleScanReportModalVisible(visible)),
        trackingHealthHistoryTabSelected: () => dispatch(trackingHealthHistoryTabSelected()),
    }
}

HealthStatsHistoryScreen = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(HealthStatsHistoryScreen));
export default translate(['stats'], { wait: true })(HealthStatsHistoryScreen);
